'use strict';

/*jshint esversion: 6 */
(function ($, Drupal) {
  'use strict';

  function formatDate(date) {
    var d = void 0;

    /* if (typeof date === 'undefined') {
      d = new Date();t
    } else { */
    d = new Date(date);
    /* } */
    var month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  // Close fropdown
  Drupal.behaviors.dropdownAjaxView = {
    attach: function attach(context, settings) {
      // Handles dropdown in view that refresh using ajax.
      console.log('test');
      $(document).on('ajaxComplete', function (event, xhr, settings) {
        $('form.views-exposed-form.bef-exposed-form details[open]').each(function () {
          $(this).find('summary').click();
        });
      });
    }
  };

  // Datepicker (flatpickr)
  Drupal.behaviors.eventDatePicker = {
    attach: function attach(context, settings) {
      $('input[name="keys"]').change(function () {
        $('.event-filters .js-form-submit').click();
      });

      var startInput = $('.event-filters input[name="start_date"]');
      var endInput = $('.event-filters input[name="end_date"]');

      startInput.change(function (e) {
        e.preventDefault();
      });

      endInput.change(function (e) {
        e.preventDefault();
      });

      var fp = $('input[name="flatpickr-input"]').flatpickr({
        mode: 'range',
        position: 'below',
        minDate: 'today',
        plugins: [ShortcutButtonsPlugin({
          button: {
            label: 'Reset'
          },
          onClick: function onClick(index, fp) {
            startInput.val('today');
            endInput.val('+400 days');
            // var sDates = [];
            // sDates.push(beforeDate.val());
            // fp.setDate(sDates);
            fp.clear();
            fp.close();
            $('.views-exposed-form input[type="submit"]').click();
          }
        })],
        onChange: function onChange(selectedDates, dateStr, instance) {
          var selectedStart = formatDate(selectedDates[0]);
          var selectedEnd = formatDate(selectedDates[1]);

          var validSelectedStart = selectedStart !== 'Invalid Date' && selectedStart !== 'NaN-NaN-NaN' && selectedStart !== 'NaN-NaN';
          var validSelectedEnd = selectedEnd !== 'Invalid Date' && selectedEnd !== 'NaN-NaN-NaN' && selectedEnd !== 'NaN-NaN';

          var selectedEndInput = $('.event-filters input[name="end_date"]');

          if (validSelectedStart) {
            startInput.val(selectedStart);
            localStorage.setItem('baccarat_event_start_date', selectedStart);
          }
          if (validSelectedEnd) {
            var endDateObject = new Date(selectedEnd);
            var endDatePlus1MilliSecs = endDateObject.setDate(endDateObject.getDate() + 1);
            var endDateMilliSecs = endDatePlus1MilliSecs + 18000000; // 180000000 = 5 hrs, just to make the end filter bump to the next day.
            var endDate = new Date(endDateMilliSecs);
            var formattedEndDate = formatDate(endDate);

            selectedEndInput.val(formattedEndDate);
            selectedEndInput[0].setAttribute('value', formattedEndDate);
            localStorage.setItem('baccarat_event_end_date', formattedEndDate);
          } else {
            selectedEndInput.val(selectedStart);
            selectedEndInput[0].setAttribute('value', selectedStart);
            localStorage.setItem('baccarat_event_end_date', selectedStart);
          }
        },
        onReady: function onReady(selectedDates, dateStr, instance) {
          var startVal = startInput.val();
          var endVal = endInput.val();
          var initEnd = endVal;
          var storedStartDate = localStorage.getItem('baccarat_event_start_date');
          var storedEndDate = localStorage.getItem('baccarat_event_end_date');
          if (storedEndDate && storedEndDate !== endVal) {
            endVal = storedEndDate;
          }

          if (startVal) {
            var endDateObject = new Date(endVal);
            var endDateMilliSecs = endDateObject.setDate(endDateObject.getDate());
            var endDate = new Date(endDateMilliSecs);
            var formattedEndDate = formatDate(endDateObject);
            if (startVal !== formattedEndDate && endVal !== formattedEndDate) {
              endDateMilliSecs = endDateObject.setDate(endDateObject.getDate() + 1);
              endDate = new Date(endDateMilliSecs);
              formattedEndDate = formatDate(endDateObject);
            }

            var startDateObject = new Date(startVal);
            var startDateMilliSecs = startDateObject.setDate(startDateObject.getDate() + 1);
            var startDate = new Date(startDateMilliSecs);
            var dateFormatOptions = { day: 'numeric', month: 'short', year: 'numeric' };

            var startDateLocal = startDate.toLocaleDateString('en-US', dateFormatOptions);
            var endDateLocal = endDate.toLocaleDateString('en-US', dateFormatOptions);
            var selectedEndInput = $('.event-filters input[name="end_date"]');

            if (startVal === formattedEndDate) {
              $('input[name="flatpickr-input"]').val(startDateLocal);
              selectedEndInput[0].setAttribute('value', startVal);
              selectedEndInput[0].value = startVal;
            } else if (endDateLocal === 'Invalid Date' || formattedEndDate === '1969-12-31') {
              $('input[name="flatpickr-input"]').val(startDateLocal);
              selectedEndInput[0].setAttribute('value', startVal);
              selectedEndInput[0].value = startVal;
            } else {
              $('input[name="flatpickr-input"]').val(startDateLocal + " - " + endDateLocal);
              selectedEndInput[0].setAttribute('value', formattedEndDate);
              selectedEndInput[0].value = formattedEndDate;
            }
            if (storedStartDate && storedEndDate && (storedStartDate !== startVal || storedEndDate !== initEnd)) {
              var submitButton = $('.views-exposed-form input[type="submit"]');
              submitButton.click();
              localStorage.removeItem('baccarat_event_start_date');
              localStorage.removeItem('baccarat_event_end_date');
            }
          }
        },
        onClose: function filterSelectedEvents(selectedDates, dateStr, instance) {
          var selectedStart = formatDate(selectedDates[0]),
              selectedEnd = formatDate(selectedDates.slice(-1));

          var endDateObject = new Date(selectedEnd);
          var endDatePlus1MilliSecs = endDateObject.setDate(endDateObject.getDate() + 1);
          var endDateMilliSecs = endDatePlus1MilliSecs + 18000000; // 180000000 = 5 hrs, just to make the end filter bump to the next day.
          var endDate = new Date(endDateMilliSecs);
          var formattedEndDate = formatDate(endDate);

          // All of this endDate Code is meant to fix the "non-inclusive between" bug.
          // Without this code, if we select a date range, the end date of the range won't be returned in the filter results.
          var validSelectedStart = selectedStart !== 'Invalid Date' && selectedStart !== 'NaN-NaN-NaN' && selectedStart !== 'NaN-NaN';
          var validSelectedEnd = selectedEnd !== 'Invalid Date' && selectedEnd !== 'NaN-NaN-NaN' && selectedEnd !== 'NaN-NaN';

          if (validSelectedEnd && validSelectedStart) {
            var selectedStartInput = $('.event-filters input[name="start_date"]');
            var selectedEndInput = $('.event-filters input[name="end_date"]');

            if (selectedStart === selectedEnd) {
              selectedStartInput.val(selectedStart);
              selectedEndInput.val(selectedStart);
              selectedEndInput[0].setAttribute('value', selectedStart);
              localStorage.setItem('baccarat_event_start_date', selectedStart);
              localStorage.setItem('baccarat_event_end_date', selectedStart);
            } else {
              selectedStartInput.val(selectedStart);
              selectedEndInput.val(formattedEndDate);
              selectedEndInput[0].setAttribute('value', formattedEndDate);
              localStorage.setItem('baccarat_event_start_date', selectedStart);
              localStorage.setItem('baccarat_event_end_date', formattedEndDate);
            }
            var submitButton = $('.views-exposed-form input[type="submit"]');
            submitButton.click();
          }
        }
      });
    }
  };
})(jQuery, Drupal);